<style scoped>
.group-line {
  min-width: 100px;
}

.grup-chip {
  min-width: 90px;
  margin: 0 auto;
}

.line-through {
  text-decoration: line-through;
}

.json {
  white-space: pre-wrap;
}
</style>

<template>
  <anchor-modal
    v-model="display"
    light
    fullscreen
    hide-overlay
    scrollable
    transition="dialog-bottom-transition"
    header-color="white"
    :header-split="true"
    :title="user ? `User History - ${user.display_name}` : 'User History'"
  >
    <v-data-table
      fixed-header
      height="82vh"
      :loading="loading"
      :headers="headers"
      :items="items"
    >
      <template v-slot:item.changes="{ item }">
        <div class="json">
          {{ item.changes | pretty }}
        </div>
      </template>
      <template v-slot:item.timestamp="{ item }">
        {{ item.timestamp | datetime }}
      </template>
    </v-data-table>
  </anchor-modal>
</template>

<script>
/* eslint no-underscore-dangle: ["error", { "allow": ["_id"] }] */
export default {
  name: 'AdminUsersHistoryModal',
  data: () => ({
    display: false,
    loading: true,
    user: null,
    history: [],
    headers: [
      { text: 'Changes', value: 'changes' },
      { text: 'Date Changed', value: 'timestamp' },
      { text: 'Event type', value: 'event' },
      { text: 'Changed By', value: 'username' },
    ],
  }),
  filters: {
    pretty(value) {
      return JSON.stringify(value, null, 2);
    },
  },
  computed: {
    items() {
      function transform(history) {
        return {
          changes: history.changes,
          username: history.username,
          event: history.event,
          timestamp: new Date(history.timestamp * 1000),
        };
      }
      return this.history.map(transform);
    },
  },
  methods: {
    open(user) {
      this.user = user;
      this.display = true;
      this.fetch();
    },
    fetch() {
      this.loading = true;
      this.$requests
        .get(`v1/users/${this.user._id}/history`)
        .then(response => {
          this.history = response.data;
        })
        .catch(() => {
          this.$toast.error('Could not resolve user history...', { timeout: 3000 });
        })
        .then(() => {
          this.loading = false;
        });
    },
  },
  watch: {
    display(value) {
      if (!value) {
        this.user = null;
        this.history = [];
      }
    },
  },
};
</script>
